// extracted by extract-css-chunks-webpack-plugin
module.exports = {"header":"header_wnwkJ"};